









// eslint-disable-next-line no-unused-vars
import { Cell } from '@/main/utils/table';

import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'LAKDRUH_OZN',
			textFieldName: 'TEXT',
			idFieldName: 'LAKDRUH_ID',
			apiProvider,
		};
	},
	methods: {
		dbToBaseMapper(data: Cell) {
			return { value: data[this.valueFieldName], text: data[this.textFieldName], id: data[this.idFieldName] };
		},
	},
});
